import { SEO } from "@/components/SEO";
import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/sections/Marquee";
import { CleanReveal } from "@/components/sections/CleanReveal";
import { Positioning } from "@/components/sections/Positioning";
import { ServiceDirectory } from "@/components/sections/ServiceDirectory";
import { DualWorlds } from "@/components/sections/DualWorlds";
import { Process } from "@/components/sections/Process";
import { Quality } from "@/components/sections/Quality";
import { B2B } from "@/components/sections/B2B";
import { Trust } from "@/components/sections/Trust";
import { QuoteSection } from "@/components/sections/QuoteSection";
import { FAQ } from "@/components/sections/FAQ";
import { FinalCta } from "@/components/sections/FinalCta";

export default function Home() {
  return (
    <>
      <SEO description="Emini Reinigung – professionelle Reinigung für Privat- und Geschäftsliegenschaften in der Deutschschweiz. Schweizer Qualität, zuverlässige Ausführung, klare Kommunikation." path="/" />
      <Hero />
      <Marquee />
      <CleanReveal />
      <Positioning />
      <ServiceDirectory />
      <DualWorlds />
      <Process />
      <Quality />
      <B2B />
      <Trust />
      <QuoteSection />
      <FAQ />
      <FinalCta />
    </>
  );
}
